'use strict';
var base = require('./base');
var baseQuickview = require('base/product/quickView');
var updateQuantityValue = require('./detail').updateQuantityValue;

const slider = require('../components/slider');
const thumbnailSelection = require('../product/detail').thumbnailSelection;

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <i class="fa-regular fa-xmark"></i>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'HTML',
        success: function (data) {
            var parsedHtml = parseHtml(data);
            let $modalBody = $('#quickViewModal .modal-body');

            $modalBody.empty();
            $modalBody.html(parsedHtml.body);
            $('#quickViewModal .modal-footer').html(parsedHtml.footer);
            $('#quickViewModal .modal-header .close .sr-only').text(parsedHtml.body.data('closeButtonText'));
            $('#quickViewModal .enter-message').text(parsedHtml.body.data('enterDialogMessage'));
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');

            // Apply slider to thumbnails in Quick view after loadig the images
            setTimeout (function () {
                slider();
            }, 500);

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

baseQuickview.showQuickview = function () {
    $('body').on('click', '.quickview', function (e) {
        e.preventDefault();
        var selectedValueUrl = $(this).closest('a.quickview').attr('href');
        $(e.target).trigger('quickview:show');
        getModalHtmlElement();
        fillModalElement(selectedValueUrl);

        // To update the primary image on selection of thumbnail
        thumbnailSelection();
    });
};

baseQuickview.productNameClick = function () {
    $('body').on('click', '.product-link', function(e) {
        if (e.ctrlKey) return; // If user click with ctrl to open in a new tab then return
        
        e.preventDefault();
        if (window.history && history.pushState) {
            var productId = $(this).data('productid');
            var params = '';

            if (window.location.search) {
                params = window.location.search + '&productId=' + productId;
            } else {
                params = '?productId=' + productId;
            }
            // Push the state to the browser history and update the URL
            history.pushState(
                { lastClickedProductId: productId },
                '',
                params
            );
        }
        window.location.href = $(this).attr('href');
    });
};

baseQuickview.scrollToLastClickedProduct = function () {
    // Read from URL
    const urlParams = new URLSearchParams(window.location.search);
    const productId = urlParams.get('productId');

    if (window.history && history.pushState && productId) {
        // Optional: clean the URL after extracting productId
        //history.replaceState({}, '', window.location.pathname);

        function removeQueryParam(key) {
            const url = new URL(window.location.href);
            url.searchParams.delete(key);
            // Update the URL without reloading the page:
            window.history.replaceState({}, document.title, url.toString());
        }

        removeQueryParam('productId');

        // Check if product is on the page yet
        const scrollToProduct = () => {
            const $product = $('.product[data-pid="' + productId + '"]');
            if ($product.length) {
                $('html, body').animate({
                    scrollTop: $product.offset().top - 100
                }, 500);
            }
        };

        scrollToProduct();
    }
};

updateQuantityValue();

baseQuickview.availability = base.availability;
baseQuickview.addToCart = base.addToCart;

module.exports = baseQuickview;
